import { render, staticRenderFns } from "./centerChild.vue?vue&type=template&id=425a402a&scoped=true"
import script from "./centerChild.vue?vue&type=script&lang=js"
export * from "./centerChild.vue?vue&type=script&lang=js"
import style0 from "./centerChild.vue?vue&type=style&index=0&id=425a402a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a402a",
  null
  
)

export default component.exports